module.exports = __webpack_public_path__ + "img/b-d.75a23d85.png";